export const modalUrlName = 'ERROR';
